'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.adaptRequest = adaptRequest;

var _generateCurlExample = require('./generateCurlExample');

var _generateCurlExample2 = _interopRequireDefault(_generateCurlExample);

var _generateNodeJSExample = require('./generateNodeJSExample');

var _generateNodeJSExample2 = _interopRequireDefault(_generateNodeJSExample);

var _generateWebJSExample = require('./generateWebJSExample');

var _generateWebJSExample2 = _interopRequireDefault(_generateWebJSExample);

var _generateTitaniumExample = require('./generateTitaniumExample');

var _generateTitaniumExample2 = _interopRequireDefault(_generateTitaniumExample);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Adapts a simple `req` object for use by the code generators.
 * The `req` has the properties:
 *  * url {string} - The request URL
 *  * method {string} - The HTTP method
 *  * headers {string[]} - An array of name value pairs, e.g. [[name, value]]
 *    (optional).
 *  * body {string|object|null} - The request body (optional).
 * @param {object} request - A request object.
 * @return {object} An adapted request for use in code generation.
 */
function adaptRequest(req) {
	var contentType = '';
	var isForm = false;
	var acceptJSON = false;

	// convert headers
	var headerPairs = [];
	for (var name in req.headers) {
		var value = req.headers[name];
		var lcName = name.toLowerCase();
		if (lcName === 'content-type') {
			if (value.startsWith('application/json')) {
				contentType = 'application/json';
			} else if (value.startsWith('multipart/form-data')) {
				contentType = 'multipart/form-data';
				isForm = true;
			} else if (value.startsWith('application/x-www-form-urlencoded')) {
				contentType = 'application/x-www-form-urlencoded';
				isForm = true;
			} else {
				contentType = value;
			}
		} else if (lcName === 'accept') {
			acceptJSON = value.startsWith('application/json');
		}
		headerPairs.push([name, value]);
	}

	var body = req.body;
	var bodyType = typeof body === 'undefined' ? 'undefined' : _typeof(body);
	var isFile = body instanceof window.File;

	// null-ish
	if (body === null || body === undefined) {
		body = null;
		bodyType = 'none';
	}
	if (isFile) {
		bodyType = 'file';
	} else if (isForm) {
		if (bodyType === 'object') {
			// Convert the body to array of [name, value]
			body = Object.entries(body);
			bodyType = 'form';

			if (!body.length) {
				body = null;
				bodyType = 'none';
			}
		}
	} else if (contentType === 'application/json') {
		bodyType = 'json';
		if (!body || !Object.keys(body).length) {
			body = null;
			bodyType = 'none';
		}
	}

	return {
		method: req.method,
		url: req.url,
		headers: headerPairs,
		acceptJSON: acceptJSON,
		contentType: contentType,
		bodyType: bodyType,
		body: body
	};
}

/**
 * Code generator.  Takes a "simple" object describing a HTTP request and
 * generates code examples from it.
 */

var CodeExampleGenerator = function () {
	_createClass(CodeExampleGenerator, null, [{
		key: 'from',

		/**
   * Build a code generator from a request.  The `request` object is a simple
   * object that describes the HTTP request to use for generating examples.  It
   * has the properties:
   *  * url {string} - The request URL
   *  * method {string} - The HTTP method
   *  * headers {string[]} - An array of name value pairs, e.g. [[name, value]]
   *    (optional).
   *  * body {string|object|null} - The request body (optional).
   * @param {object} request - A request object.
   * @public
   * @static
   */
		value: function from(request) {
			return new CodeExampleGenerator(adaptRequest(request));
		}

		/**
   * Build a code generator from a request.
   * @private
   */

	}]);

	function CodeExampleGenerator(request) {
		_classCallCheck(this, CodeExampleGenerator);

		this.request = request;
	}

	/**
  * Generate a code example.
  * @param {string} type - The code type, one of: curl, node, web, titanium
  * @param {string} comment - A comment to apply to the generated code.
  * @public
  */


	_createClass(CodeExampleGenerator, [{
		key: 'generate',
		value: function generate(type, comment) {
			switch (type) {
				case 'curl':
					return (0, _generateCurlExample2.default)(this.request, comment);
				case 'node':
					return (0, _generateNodeJSExample2.default)(this.request, comment);
				case 'web':
					return (0, _generateWebJSExample2.default)(this.request, comment);
				case 'titanium':
					return (0, _generateTitaniumExample2.default)(this.request, comment);
			}
		}
	}]);

	return CodeExampleGenerator;
}();

var _default = CodeExampleGenerator;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(adaptRequest, 'adaptRequest', 'src/utility/CodeExampleGenerator.js');

	__REACT_HOT_LOADER__.register(CodeExampleGenerator, 'CodeExampleGenerator', 'src/utility/CodeExampleGenerator.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/utility/CodeExampleGenerator.js');
}();

;